//Bu satırda Redux’un createStore fonksiyonu çağrılıyor ama legacy_createStore adıyla.
import { legacy_createStore as createStore } from 'redux'

//Uygulamanın başlangıç durumunu tanımlar:
//Sidebar açık olarak başlasın ve ema açık (light mode) olarak başlasın
const initialState = {
    sidebarShow: true,
    theme: 'light',
}

//Bu fonksiyon, Redux’un kalbi olan reducer fonksiyonudur. Gelen action'lara göre state'i nasıl güncelleyeceğini tanımlar:
const changeState = (state = initialState, { type, ...rest }) => {
    switch (type) {
        //Eğer gelen action.type === 'set' ise, ...rest içindeki değerleri mevcut state'e ekleyip günceller.
            //dispatch({ type: 'set', sidebarShow: false }) gibi değer gönderilirse
            //Bu durumda yeni state şöyle olur:  sidebarShow: false, theme: 'light'
        case 'set':
            return { ...state, ...rest }
        // Eğer type başka bir şeyse (veya boşsa), eski state olduğu gibi döner.
        default:
            return state
    }
}

//Redux store, yukarıdaki reducer fonksiyonu (changeState) kullanılarak oluşturuluyor ve dışa aktarılıyor.
//Bu store'u React projenin kökünde Provider içine vererek global state yönetimini başlatabilirsin.
const store = createStore(changeState)
export default store